import React, { createContext, type Dispatch, type ReactNode, useReducer } from 'react'

import type { WorkId } from '../../../../types/WorkId'
import type { WorkData } from '../../../../types/Work'
import { reducer } from './reducer'
import type { WorkDataAction } from './WorkDataAction'

export type IWorksDataContext = {
  worksData: Record<WorkId, WorkData>
  isWorkQuantitiesValid: boolean
  isPrimaryProjectWorkQuantitiesValid: boolean
}

export const WorksDataContext = createContext({} as IWorksDataContext)
export const WorksDataDispatch = createContext<Dispatch<WorkDataAction>>(() => null)

const initialState: IWorksDataContext = {
  worksData: {},
  isWorkQuantitiesValid: false,
  isPrimaryProjectWorkQuantitiesValid: false,
}

export const WorksDataProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <WorksDataDispatch.Provider value={dispatch}>
      <WorksDataContext.Provider value={state}>{children}</WorksDataContext.Provider>
    </WorksDataDispatch.Provider>
  )
}
